import { _system } from '@umu/ukit-lang';
import { $location } from '@umu/umu-dom';

export const getCDNDomain = () => {
    if (_system('CN')) {
        return 'https://statics-cdn-cn.umucdn.cn';
    }

    return 'https://cdn.umustatic.com';
};

export const getPDFDomain = () => {
    if (_system('EN')) {
        return 'https://d1bvk99i2a79wx.cloudfront.net';
    }
    if (_system('EM')) {
        return 'https://cdn.umu.io';
    }
    if (_system('JP')) {
        return 'https://dpfrzbu0cqnmm.cloudfront.net';
    }
    if (_system('TW')) {
        return 'https://d1yemi1ss2f2oh.cloudfront.net';
    }

    return 'https://statics-cdn-cn.umucdn.cn';
};

// 获取勋章 icon 的 cdn 地址
export const getMedalIcon = (type: string, rank: string | number, size: 'L' | 'S' = 'L') => {
    const getBaseUrl = () => {
        let url = getPDFDomain();
        url += '/cdn/image';

        // 目录
        let dir = '/achievement';
        if (!_system('cn')) {
            dir = dir + '/global';
        }

        return url + dir;
    };

    // 默认返回大尺寸
    size = size || 'L';

    if (!type || !rank) {
        return;
    }

    let ret = '';
    ret = `/medal_${size}/${type}_${rank}`;
    ret = `${getBaseUrl() + ret}.png`;

    // 勋章图的版本号。如果有更新，需要修改版本号清缓存
    const MEDAL_ICON_VERSION = '4';

    // 添加版本信息
    if (MEDAL_ICON_VERSION) {
        ret += `?${MEDAL_ICON_VERSION}`;
    }
    return ret;
};

export const getProfileIndexUrl = (profileId: string) => {
    const host = $location.host.replace('www.', 'm.');
    return `${$location.protocol}//${host}/profile/${profileId}`;
};
